import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function InternationalStudent() {
  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dkt3.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    🌍 INTERNATIONAL STUDENTS
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  International Student
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  Your guide to joining DTK College from anywhere in the world
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        <section id="international-student" className="international-student section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            {/* Application Steps */}
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                {/* Step 1: Course Selection */}
                <div className="mb-4" data-aos="fade-up" data-aos-delay="100">
                  <div className="d-flex align-items-start">
                    <div className="me-4" style={{ 
                      minWidth: '70px',
                      height: '70px',
                      background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.8rem',
                      fontWeight: '700',
                      color: 'white',
                      flexShrink: 0,
                      boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                      border: '4px solid #F5EBFA'
                    }}>
                      1
                    </div>
                    <div className="flex-grow-1 p-4 shadow" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      borderLeft: '4px solid #7B3F9E',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 63, 158, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}>
                      <h3 className="mb-3" style={{ 
                        color: '#7B3F9E', 
                        fontSize: '1.4rem', 
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <i className="bi bi-search"></i>Course Selection
                      </h3>
                      <p style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8', 
                        marginBottom: '0' 
                      }}>
                        Carefully choose the course which is right for you. If you require assistance please contact the 
                        Admissions Office. Most overseas students will choose an Academic course track in Business or 
                        Computing which are for paths to further study leading to British or international bachelors or 
                        masters degree.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Step 2: Complete Enrolment Form */}
                <div className="mb-4" data-aos="fade-up" data-aos-delay="150">
                  <div className="d-flex align-items-start">
                    <div className="me-4" style={{ 
                      minWidth: '70px',
                      height: '70px',
                      background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.8rem',
                      fontWeight: '700',
                      color: 'white',
                      flexShrink: 0,
                      boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                      border: '4px solid #F5EBFA'
                    }}>
                      2
                    </div>
                    <div className="flex-grow-1 p-4 shadow" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      borderLeft: '4px solid #7B3F9E',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 63, 158, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}>
                      <h3 className="mb-3" style={{ 
                        color: '#7B3F9E', 
                        fontSize: '1.4rem', 
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <i className="bi bi-file-text"></i>Complete an Enrolment Form
                      </h3>
                      <p style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8', 
                        marginBottom: '0' 
                      }}>
                        After choosing your course you can complete our Admission Form which can be downloaded from here 
                        and emailed, faxed or posted to us. Please take care to write the correct start dates, course name 
                        and code.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Step 3: Await Conditional Offer */}
                <div className="mb-4" data-aos="fade-up" data-aos-delay="200">
                  <div className="d-flex align-items-start">
                    <div className="me-4" style={{ 
                      minWidth: '70px',
                      height: '70px',
                      background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.8rem',
                      fontWeight: '700',
                      color: 'white',
                      flexShrink: 0,
                      boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                      border: '4px solid #F5EBFA'
                    }}>
                      3
                    </div>
                    <div className="flex-grow-1 p-4 shadow" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      borderLeft: '4px solid #7B3F9E',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 63, 158, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}>
                      <h3 className="mb-3" style={{ 
                        color: '#7B3F9E', 
                        fontSize: '1.4rem', 
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <i className="bi bi-envelope-check"></i>Await a Conditional Offer
                      </h3>
                      <p style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8', 
                        marginBottom: '1rem' 
                      }}>
                        The College will acknowledge the receipt of your application within 7 days (faster if you supply an 
                        email address). If your application is successful you will be sent by post a conditional offer of a 
                        place on your chosen course along with other documentation including a guide to expenses (these costs 
                        are only an indication of living expenses) and total cost of tuition fees.
                      </p>
                      <p style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8', 
                        marginBottom: '0' 
                      }}>
                        The offer is proof that you meet the entry requirements and is conditional subject to the receipt of 
                        your tuition fees.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Step 4: Supporting Documentation */}
                <div className="mb-4" data-aos="fade-up" data-aos-delay="250">
                  <div className="d-flex align-items-start">
                    <div className="me-4" style={{ 
                      minWidth: '70px',
                      height: '70px',
                      background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.8rem',
                      fontWeight: '700',
                      color: 'white',
                      flexShrink: 0,
                      boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                      border: '4px solid #F5EBFA'
                    }}>
                      4
                    </div>
                    <div className="flex-grow-1 p-4 shadow" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      borderLeft: '4px solid #7B3F9E',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 63, 158, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}>
                      <h3 className="mb-3" style={{ 
                        color: '#7B3F9E', 
                        fontSize: '1.4rem', 
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <i className="bi bi-folder-check"></i>Provide Supporting Documentation
                      </h3>
                      <p className="mb-3" style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8' 
                      }}>
                        DTK College requires the following additional documentation to process your application for admission:
                      </p>
                      <ul style={{ 
                        paddingLeft: '1.5rem', 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8',
                        marginBottom: '1.5rem'
                      }}>
                        <li className="mb-2">A signed enrolment form</li>
                        <li className="mb-2">One passport size photograph</li>
                        <li className="mb-2">Photocopies of educational qualifications – diploma, degree, and College or school results</li>
                        <li className="mb-2">If you are applying as a mature student with no previous academic qualifications please provide your CV/Resume and employers references</li>
                        <li className="mb-2">The course tuition fees of <strong style={{ color: '#7B3F9E' }}>£1000</strong> for certification courses</li>
                      </ul>
                      <div style={{
                        backgroundColor: '#F5EBFA',
                        padding: '15px 20px',
                        borderRadius: '10px',
                        borderLeft: '4px solid #7B3F9E'
                      }}>
                        <p style={{ 
                          color: '#6B2F8E', 
                          fontSize: '0.95rem', 
                          lineHeight: '1.7', 
                          marginBottom: '0',
                          fontWeight: '500'
                        }}>
                          <i className="bi bi-info-circle me-2"></i>
                          Please note that students of some foreign nationals are required to pay the course fees in full to obtain entry clearance.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Step 5: Pay Tuition Fees */}
                <div className="mb-4" data-aos="fade-up" data-aos-delay="300">
                  <div className="d-flex align-items-start">
                    <div className="me-4" style={{ 
                      minWidth: '70px',
                      height: '70px',
                      background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.8rem',
                      fontWeight: '700',
                      color: 'white',
                      flexShrink: 0,
                      boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                      border: '4px solid #F5EBFA'
                    }}>
                      5
                    </div>
                    <div className="flex-grow-1 p-4 shadow" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      borderLeft: '4px solid #7B3F9E',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 63, 158, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}>
                      <h3 className="mb-3" style={{ 
                        color: '#7B3F9E', 
                        fontSize: '1.4rem', 
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <i className="bi bi-credit-card"></i>Pay Tuition Fees / Await Confirmed Offer
                      </h3>
                      <p className="mb-3" style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8' 
                      }}>
                        Payment of fees from outside the UK is easiest by either:
                      </p>
                      <ul style={{ 
                        paddingLeft: '1.5rem', 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8',
                        marginBottom: '1rem'
                      }}>
                        <li className="mb-2">
                          <strong style={{ color: '#7B3F9E' }}>Banker's Draft</strong> (also known as a Bank Cheque or Demand Draft) made payable to 
                          the 'DTK' and sent along with the above documents by courier or registered mail
                        </li>
                        <li className="mb-2">
                          <strong style={{ color: '#7B3F9E' }}>Electronic Funds Transfer (EFT)</strong> payment to the College account ensuring that 
                          you quote your Student Number on the payment
                        </li>
                      </ul>
                      <p style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8', 
                        marginBottom: '0' 
                      }}>
                        Once your supporting documentation and tuition fees have been received your application status becomes 
                        confirmed and you will be sent an 'Acceptance Letter' and are ready to apply for a UK student visa.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Step 6: Entry Clearance */}
                <div className="mb-4" data-aos="fade-up" data-aos-delay="350">
                  <div className="d-flex align-items-start">
                    <div className="me-4" style={{ 
                      minWidth: '70px',
                      height: '70px',
                      background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.8rem',
                      fontWeight: '700',
                      color: 'white',
                      flexShrink: 0,
                      boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                      border: '4px solid #F5EBFA'
                    }}>
                      6
                    </div>
                    <div className="flex-grow-1 p-4 shadow" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      borderLeft: '4px solid #7B3F9E',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 63, 158, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}>
                      <h3 className="mb-3" style={{ 
                        color: '#7B3F9E', 
                        fontSize: '1.4rem', 
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <i className="bi bi-passport"></i>Obtain Entry Clearance or Visa at Port of Entry*
                      </h3>
                      <p className="mb-3" style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8' 
                      }}>
                        Some overseas students are required to obtain 'Entry Clearance' from the British High Commission or 
                        British Embassy in their home country.
                      </p>
                      <p className="mb-3" style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8' 
                      }}>
                        (For more information about obtaining a student visa and entry clearance, please contact the Admission Office).
                      </p>
                      <p style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8', 
                        marginBottom: '15px' 
                      }}>
                        Once you have obtained a student visa you are ready to make travel and accommodation arrangements.
                      </p>
                      <div style={{
                        backgroundColor: '#F5EBFA',
                        padding: '10px 15px',
                        borderRadius: '8px',
                        borderLeft: '3px solid #7B3F9E'
                      }}>
                        <p style={{ 
                          color: '#6B2F8E', 
                          fontSize: '0.9rem', 
                          lineHeight: '1.6', 
                          marginBottom: '0',
                          fontStyle: 'italic'
                        }}>
                          *depends on nationality
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Step 7: Reserve Accommodation */}
                <div className="mb-4" data-aos="fade-up" data-aos-delay="400">
                  <div className="d-flex align-items-start">
                    <div className="me-4" style={{ 
                      minWidth: '70px',
                      height: '70px',
                      background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.8rem',
                      fontWeight: '700',
                      color: 'white',
                      flexShrink: 0,
                      boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                      border: '4px solid #F5EBFA'
                    }}>
                      7
                    </div>
                    <div className="flex-grow-1 p-4 shadow" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      borderLeft: '4px solid #7B3F9E',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 63, 158, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}>
                      <h3 className="mb-3" style={{ 
                        color: '#7B3F9E', 
                        fontSize: '1.4rem', 
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <i className="bi bi-house-heart"></i>Reserve Accommodation
                      </h3>
                      <p style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8', 
                        marginBottom: '0' 
                      }}>
                        DTK College can arrange accommodation for you. You must first request an accommodation application form, 
                        complete, sign and return it to the Accommodation Office.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Step 8: Enter the UK */}
                <div className="mb-5" data-aos="fade-up" data-aos-delay="450">
                  <div className="d-flex align-items-start">
                    <div className="me-4" style={{ 
                      minWidth: '70px',
                      height: '70px',
                      background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.8rem',
                      fontWeight: '700',
                      color: 'white',
                      flexShrink: 0,
                      boxShadow: '0 4px 15px rgba(123, 63, 158, 0.3)',
                      border: '4px solid #F5EBFA'
                    }}>
                      8
                    </div>
                    <div className="flex-grow-1 p-4 shadow" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      borderLeft: '4px solid #7B3F9E',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 63, 158, 0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}>
                      <h3 className="mb-3" style={{ 
                        color: '#7B3F9E', 
                        fontSize: '1.4rem', 
                        fontWeight: '700',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}>
                        <i className="bi bi-airplane"></i>Enter the UK
                      </h3>
                      <p className="mb-3" style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8' 
                      }}>
                        UK immigration officials at passport control in your UK port of entry will ask to see your Acceptance 
                        Letter confirming your place on a course and that fees have been paid. They may also ask for evidence of 
                        living expenses for approximately 3 months.
                      </p>
                      <p style={{ 
                        color: '#475569', 
                        fontSize: '1.05rem', 
                        lineHeight: '1.8', 
                        marginBottom: '0' 
                      }}>
                        The student must be able to satisfy immigration that their financial status is sufficient to cover both 
                        the tuition fees and living expenses for the period of stay in the UK.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default InternationalStudent;